import { render, staticRenderFns } from "./CommunityAppStoreListItem.vue?vue&type=template&id=0218769c&"
import script from "./CommunityAppStoreListItem.vue?vue&type=script&lang=js&"
export * from "./CommunityAppStoreListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports